import Comm from "../../core/src/controllers/BaseComm";
import { IRequestBuilder } from "../../core/src/server/requests/RequestBuilder";
import StateMachine from "../../core/src/states/StateMachine";
import ErrorModel from "../../core/src/model/ErrorModel";

export default class RelaxComm extends Comm {
    send(
        request: IRequestBuilder,
        callback: (...args: any[]) => void,
        callbackScope: any,
        errorCallback?: (...args: any[]) => void,
        withCredentials = false
    ) {
        super.send(
            request,
            callback,
            callbackScope,
            errorCallback || this.defaultErrorHandler,
            withCredentials
        );
    }

    defaultErrorHandler(response: any) {
        console.log("[RelaxComm] Handle Error:", response);

        if (response.type && response.type == "error") {
            console.log("[RelaxComm] Error model:", response);
            ErrorModel.update({
                errorCode: 404,
                errorMessage: "Connection error!",
                critical: true,
            });
        } else {
            ErrorModel.update(response);
        }

        StateMachine.skip();
    }

    checkForGlobalErrors(response: any) {
        if (response && (response.errorCode || response.errorMessage)) {
            return true;
        } else {
            return false;
        }
    }
}
